import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-556772d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "question-note" }, "\n      選択した転職意欲に応じて、応募実績のある事業所から採用やお仕事に関するスカウトメッセージが届くことがあります\n    ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_BModal = _resolveComponent("BModal")!

  return (_openBlock(), _createBlock(_component_BModal, {
    visible: _ctx.internalIsShowModal,
    title: "今の転職意欲を教えてください",
    "no-close-on-backdrop": "",
    "no-close-on-esc": "",
    "hide-header-close": "",
    "hide-footer": "",
    centered: ""
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.jobOptions, (jobOption) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "button-container",
          key: jobOption.id
        }, [
          _createVNode(_component_AppButton, {
            onClick: ($event: any) => (_ctx.onClick(jobOption.id)),
            class: "button"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(jobOption.level), 1)
            ], undefined, true),
            _: 2
          }, 1032, ["onClick"])
        ]))
      }), 128)),
      _createTextVNode(),
      _hoisted_1
    ], undefined, true),
    _: 1
  }, 8, ["visible"]))
}